import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DefaultStyles from '@shared/components/core/structure/DefaultStyles';
import { ThemeContextLoader } from '@shared/components/loading/ThemeContextLoader';
import AlertsContainer from '@shared/hooks/state/AlertsContainer';
import AnalyticsTrackingContainer from '@shared/hooks/state/AnalyticsTrackingContainer';
import AuthContainer from '@shared/hooks/state/AuthContainer';
import CurrentDeviceContainer from '@shared/hooks/state/CurrentDeviceContainer';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import DeviceContainer from '@shared/hooks/state/DeviceContainer';
import EditDeviceTypeContainer from '@shared/hooks/state/EditDeviceTypeContainer';
import EditProfileContainer from '@shared/hooks/state/EditProfileContainer';
import GlobalCustomControlsContainer from '@shared/hooks/state/GlobalCustomControlsContainer';
import NotificationContainer from '@shared/hooks/state/NotificationContainer';
import OrganizationContainer from '@shared/hooks/state/OrganizationContainer';
import ProfilesContainer from '@shared/hooks/state/ProfilesContainer';
import PublicProfilesContainer from '@shared/hooks/state/PublicProfilesContainer';
import Layout from 'admin/pages/layout';

const AppWithProviders = () => {
    (window as any).ADMIN_ENVIRONMENT = 'true';
    (window as any).commandHandlers = [];
    (window as any).commandMacroHandler = [];

    return (
        <ThemeContextLoader>
            <DefaultStyles>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <AnalyticsTrackingContainer.Provider>
                        <AlertsContainer.Provider>
                            <AuthContainer.Provider>
                                <CurrentUserContainer.Provider>
                                    <OrganizationContainer.Provider>
                                        <DeviceContainer.Provider>
                                            <CurrentDeviceContainer.Provider>
                                                <GlobalCustomControlsContainer.Provider>
                                                    <ProfilesContainer.Provider>
                                                        <PublicProfilesContainer.Provider>
                                                            <EditDeviceTypeContainer.Provider>
                                                                <EditProfileContainer.Provider>
                                                                    <NotificationContainer.Provider>
                                                                        <Layout />
                                                                    </NotificationContainer.Provider>
                                                                </EditProfileContainer.Provider>
                                                            </EditDeviceTypeContainer.Provider>
                                                        </PublicProfilesContainer.Provider>
                                                    </ProfilesContainer.Provider>
                                                </GlobalCustomControlsContainer.Provider>
                                            </CurrentDeviceContainer.Provider>
                                        </DeviceContainer.Provider>
                                    </OrganizationContainer.Provider>
                                </CurrentUserContainer.Provider>
                            </AuthContainer.Provider>
                        </AlertsContainer.Provider>
                    </AnalyticsTrackingContainer.Provider>
                </LocalizationProvider>
            </DefaultStyles>
        </ThemeContextLoader>
    );
};

export default AppWithProviders;
